import { Button } from "@/base/components/button/Button.component";
import { CMP_PREFIX } from "@/base/constant";
import {
  SearchIcon,
  VisibilityIcon,
  VisibilityOffIcon,
} from "@/base/static/index";
import {
  Input as AntdInput,
  InputProps as AntdInputProps,
  InputRef,
  Space,
} from "antd";
import {
  GroupProps as AntdGroupProps,
  PasswordProps as AntdPasswordProps,
  SearchProps as AntdSearchProps,
  TextAreaProps as AntdTextAreaProps,
} from "antd/lib/input";
import { useRef } from "react";

export interface InputProps extends AntdInputProps {}
export interface TextAreaProps extends AntdTextAreaProps {}
export interface InputPasswordProps extends AntdPasswordProps {}
export interface InputGroupProps extends AntdGroupProps {}
export interface InputSearchProps extends AntdSearchProps {}

export const inputPrefixCls = `${CMP_PREFIX}-input`;

export const Input = ({ size = "large", ...props }: InputProps) => {
  return <AntdInput size={size} {...props} />;
};

export const TextArea = ({ ...props }: TextAreaProps) => {
  return <AntdInput.TextArea {...props} />;
};

export const InputPassword = ({
  size = "large",
  ...props
}: InputPasswordProps) => {
  return (
    <AntdInput.Password
      size={size}
      iconRender={(visible) =>
        visible ? <VisibilityIcon /> : <VisibilityOffIcon />
      }
      {...props}
    />
  );
};

export const InputSearch = ({
  size = "large",
  onSearch,
  onPressEnter,
  ...props
}: InputSearchProps) => {
  const inputRef = useRef<InputRef>(null);

  const handleSearch = (
    value: string,
    event?:
      | React.ChangeEvent<HTMLInputElement>
      | React.MouseEvent<HTMLElement>
      | React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (onSearch) {
      onSearch(value, event);
    }
  };

  const handlePressEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (onPressEnter) {
      onPressEnter(e);
    }
    if (onSearch && e.currentTarget.value !== undefined) {
      onSearch(e.currentTarget.value, e);
    }
  };

  const handleButtonClick = (e: React.MouseEvent<HTMLElement>) => {
    const input = inputRef.current?.input;
    if (input && onSearch) {
      handleSearch(input.value, e);
    }
  };

  return (
    <Space.Compact style={{ width: "100%" }}>
      <AntdInput
        ref={inputRef}
        size={size}
        onPressEnter={handlePressEnter}
        {...props}
      />
      <Button
        type="primary"
        size={size}
        icon={<SearchIcon />}
        onClick={handleButtonClick}
      />
    </Space.Compact>
  );
};

export const InputGroup = ({ ...props }: InputGroupProps) => {
  return <AntdInput.Group {...props} />;
};
